const CalculationTypes: any = {
  FLAT_AMOUNT: 'Flat Amount',
  PER_TRANSACTION_AMOUNT: 'Per transaction amount',
};

export default CalculationTypes;
